import Vue from 'vue'
import Router from 'vue-router'
import House from './views/HouseManage.vue'
import Account from './views/Account.vue'
import Abnormal from './views/Abnormal.vue'
import Report from './views/Report.vue'
import Finance from './views/Finance.vue'
import Login from './views/Login.vue'
import NoLogin from './views/NoLogin.vue'
import NewHome from  './views/newHome1.vue'
// import UpdateDoc from './views/UpdateDoc.vue'


import purse from './views/purse.vue'
import personal from './views/personal.vue'
import setup from './views/setup.vue'
import help from './views/help.vue'
import onlyPC from './views/OnlyPC.vue'

Vue.use(Router);

export default new Router({
  routes: [
      {
          path: '/home',
          name: 'home',
          component: NewHome
      },
      {
          path: '/',
          name: 'login',
          component: Login
      },
      {
          path: '/house',
          name: 'house',
          component: House,
      },
      {
          path: '/account',
          name: 'account',
          component: Account
      },
      {
          path: '/abnormal',
          name: 'abnormal',
          component: Abnormal
      },
      {
          path: '/report',
          name: 'report',
          component: Report
      },
      {
          path: '/finance',
          name: 'finance',
          component: Finance
      },
      {
          path: '/purse',
          name: 'purse',
          component: purse
      },
      {
          path: '/personal',
          name: 'personal',
          component: personal
      },
      {
          path: '/setup',
          name: 'setup',
          component: setup
      },
      {
          path: '/help',
          name: 'help',
          component: help
      },
      {
          path: '/onlyPC',
          name: 'onlyPC',
          component: onlyPC,
      },
  ]
})
